/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { NotificationSettingRequest } from '../../models/notification-setting-request';
import { NotificationSettingResponse } from '../../models/notification-setting-response';

export interface ReplaceNotificationSetting$Params {
  organizationSiteKey: KeyType;
      body: NotificationSettingRequest
}

export function replaceNotificationSetting(http: HttpClient, rootUrl: string, params: ReplaceNotificationSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationSettingResponse>> {
  const rb = new RequestBuilder(rootUrl, replaceNotificationSetting.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationSettingResponse>;
    })
  );
}

replaceNotificationSetting.PATH = '/organization-sites/{organizationSiteKey}/settings/notifications';
